export class ApprovalDataModel {
  tblApprovalDataId: number = 0;
  FormId: string = "";
  PKTableId: number = 0;
  clientId: number = 0;
  isApproved?: boolean = null;
  approvedByEmployeeId?: number = null;
  approvedByUserId: string = "";
  notes: string = "";
  approvalDate?: Date = null;


  isActive: boolean = true;
  isDelete: boolean = false;
  isDeactivate: boolean = false;
  createdOnUTC: Date = new Date();
  createdBy: string = "";
  updatedOnUTC: Date = new Date();
  updatedBy: string = ""; 
}

export class ApprovalConfigurationModel {
  formId: string = "";
  formTitle: string = "Approval Process";
  addFormName: string = "Approve/Reject";
  editFormName: string = "";
  listReportFormName: string = "";

  
  addEditInModalPopUp: boolean = true;
  allowAdd: boolean = true;
  allowEdit: boolean = true;
  allowDelete: boolean = true;
  displayListCardView: boolean = false;
  
  requiredFields: RequiredFields = new RequiredFields();
  allowedFields: AllowedFields = new AllowedFields();
  fieldsTitle: FieldsTitle = new FieldsTitle();
  templateName: string = "popup-ui";//popup-ui (e.g. leak-logic lead form) | static-ui (imvo > requests form)
  autoSave: boolean = false;
  isDisabled: boolean = false;
}
export class RequiredFields {
  notes: boolean = true;
}

export class AllowedFields {
  notes: boolean = true;
}
export class FieldsTitle {
  
}
export class ValidationModel {
  isNotesValid: boolean = true;
  notesValidationMessage: string = "Please Enter Notes";
}
